import { render, staticRenderFns } from "./SplitDetailManage.vue?vue&type=template&id=8ad76894&scoped=true"
import script from "./SplitDetailManage.vue?vue&type=script&lang=js"
export * from "./SplitDetailManage.vue?vue&type=script&lang=js"
import style0 from "./SplitDetailManage.vue?vue&type=style&index=0&id=8ad76894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad76894",
  null
  
)

export default component.exports